import React, { useState } from 'react';
import { Button, Checkbox } from '@tencent/spaui';
import { useTypedSelector } from 'store/index';

type License = Record<'url' | 'track' | 'label', string>;

interface Props {
  id: 'auth' | 'app-auth' | 'wechat-oauth';
  clientId: string;
  licenses: License[];
  loading: boolean;
  disabled?: boolean;
  btnLabel: string;
  onConfirm: () => void;
}

const Bottom: React.FC<Props> = (props) => {
  const { id, clientId, licenses, loading, disabled, btnLabel, onConfirm } = props;
  const {
    user: { user },
  } = useTypedSelector((state) => state);
  const key = `license-${id}-${user?.user_id}-${clientId}`;
  const [read, setRead] = useState<boolean>(localStorage.getItem(key) === 'true');

  return (
    <div className="bottom">
      <Checkbox
        checked={read}
        onChange={() => {
          setRead(!read);
          localStorage.setItem(key, String(!read));
        }}
      >
        已阅读并同意
        {licenses.map(({ url, track, label }) => (
          <a key={label} href={url} target="_blank" rel="noreferrer" data-track={track}>
            《{label}》
          </a>
        ))}
      </Checkbox>
      <Button
        className="rect-button"
        displayType="primary"
        disabled={disabled ? disabled : !read}
        loading={loading}
        onClick={onConfirm}
      >
        {btnLabel}
      </Button>
    </div>
  );
};

export default Bottom;
